<ion-grid class="bottom-bar">
  <ion-row>
    <!-- Link Resumen -->
    <ion-col size="6">
      <getm-button
        class="summary-link"
        [text]="'Buttons.summary' | translate"
        icon="chevron-down-outline"
        iconSlot="end"
        color="link"
        [disabled]="!showSummary"
        (btnClick)="onSummaryClick()"
      ></getm-button>
    </ion-col>

    <!-- Botón principal -->
    <ion-col size="6">
      <getm-button
        class="action-button"
        [text]="
          (isLastLevel ? 'Buttons.add-to-cart' : 'Buttons.next-level') | translate
        "
        color="primary"
        size="default"
        expand="block"
        [disabled]="!canConfirm"
        (btnClick)="onActionClick()"
      ></getm-button>
    </ion-col>
  </ion-row>
</ion-grid>